import { Injectable, signal } from '@angular/core';
import { AppConfigService } from '@app/core/config/app-config.service';

@Injectable({ providedIn: 'root' })
export class VersionUpdateService {
  private readonly startupVersion: string | null;
  private readonly updateDetected = signal(false);

  public readonly updateAvailable = this.updateDetected.asReadonly();

  constructor(appConfigService: AppConfigService) {
    this.startupVersion = appConfigService.settings.version ?? null;
  }

  public inspectServedVersion(version: string | null): void {
    if (this.updateDetected()) {
      return;
    }

    if (!this.startupVersion || !version || version === this.startupVersion) {
      return;
    }

    this.updateDetected.set(true);
  }
}
